import React from 'react';
import styled from 'fe-styled-components';
import PropTypes from 'prop-types';
import theme, { rems } from 'fe-appdir-lib-theme';
import { SvgIcon, BoxArrowTopRightOutline } from 'fe-comp-svg-icon';

const PROP_TYPES = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  gaTrackId: PropTypes.string,
  gaTrackInfo: PropTypes.string,
};

const Link = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  margin-right: ${theme.marginBasePlusHalf};
  display: flex;
  align-items: flex-start;
  text-decoration: none;

  color: ${theme.colorLink};
  fill: ${theme.colorLink};
  transition: color 0.15s ease-out, fill 0.15s ease-out;

  &:focus,
  &:hover,
  &:active {
    color: ${theme.colorLinkActive};
    fill: ${theme.colorLinkActive};
  }

  &:last-of-type {
    margin-right: 0;
  }
`;

const Icon = styled.span`
  margin-right: ${theme.marginBase};
  fill: inherit;
`;

const Label = styled.span`
  color: inherit;
  font-size: ${theme.fontSizeBase};
  font-weight: ${theme.fontWeightSemibold};
  margin-top: ${rems(3)};
`;

const ExternalLink = ({ label, href, gaTrackId, gaTrackInfo }) => {
  return (
    <Link href={href} data-ga-track-id={gaTrackId} data-ga-track-info={gaTrackInfo}>
      <Icon>
        <SvgIcon glyph={BoxArrowTopRightOutline} size={18} fill="inherit" />
      </Icon>
      <Label>{label}</Label>
    </Link>
  );
};

ExternalLink.propTypes = PROP_TYPES;

export default ExternalLink;
